export enum DatasetJobStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Working = 'Working',
  Completed = 'Completed',
  Active = 'Active'
}
